"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _middleware = require("../middleware");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var runDispatchPipeline = function runDispatchPipeline(storeItem, state, payload, store, modules) {
  var _payload$options, _payload$options2;

  var stateName = Object.keys(storeItem.state)[0];
  var dispatchValue = payload[storeItem.action];
  var disableMiddleware = (_payload$options = payload.options) === null || _payload$options === void 0 ? void 0 : _payload$options.disableMiddleware;
  var allowPayloadListeners = (_payload$options2 = payload.options) === null || _payload$options2 === void 0 ? void 0 : _payload$options2.allowPayloadListeners;
  var middlewareData = (0, _middleware.createMiddlewareData)(dispatchValue, payload, storeItem, state, store, modules);

  if (allowPayloadListeners) {
    (0, _middleware.runPayloadListeners)(payload, modules);
  }

  if ((payload === null || payload === void 0 ? void 0 : payload.reducerAction) !== undefined) {
    if (!disableMiddleware) {
      var middlewareValue = (0, _middleware.runMiddleware)(middlewareData);

      if (middlewareValue !== null) {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, stateName, middlewareValue));
      }

      return _objectSpread({}, state);
    }
  }

  var reducerActionValue = (payload === null || payload === void 0 ? void 0 : payload.reducerAction) !== undefined ? (0, _middleware.runReducerActions)(middlewareData) : dispatchValue;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, stateName, reducerActionValue));
};

var _default = runDispatchPipeline;
exports["default"] = _default;
module.exports = exports.default;